import { Icon } from "./Icon.tsx";

/** A frame with a header divider and column dividers, distinct from
 * LayoutGridIcon.tsx's 4 equal, separate squares. */
export function ResultsDashboardTableIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="18" height="16" rx="1" />
      <path d="M3 9h18" />
      <path d="M9 9v11M15 9v11" />
    </Icon>
  );
}
